import { Brain, Heart, Star, Sparkles, Shield, BookOpen } from 'lucide-react';

const benefits = [
  {
    icon: Brain,
    title: "Sistem Dovedit de 5 Pași",
    desc: "Metodologie practică testată cu peste 10,000 de cititori pentru a transforma depresia în motivație și putere interioară"
  },
  {
    icon: Heart,
    title: "Tehnici de Auto-Vindecare",
    desc: "Exerciții zilnice de mindfulness și strategii cognitive care te ajută să ieși din spirala gândurilor negative (15-30 minute/zi)"
  },
  {
    icon: Star,
    title: "Rezultate Concrete",
    desc: "98% dintre cititori raportează îmbunătățiri semnificative în primele 30 de zile de aplicare a metodelor din carte"
  },
  {
    icon: Sparkles,
    title: "Transformare Garantată",
    desc: "De la 'Nu mai pot' la 'Sunt mai puternic ca niciodată' - urmează sistemul pas cu pas și vezi rezultatele imediat"
  },
  {
    icon: Shield,
    title: "Kit Complet Anti-Depresie",
    desc: "27 de exerciții practice, 5 tehnici de urgență pentru atacuri de panică și jurnal structurat pentru monitorizarea progresului"
  },
  {
    icon: BookOpen,
    title: "Experiență Personală Reală",
    desc: "Scrisă din tranșee - am trecut personal prin depresie severă și am dezvoltat aceste tehnici prin încercări și greșeli"
  }
];

export function Benefits() {
  return (
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8 lg:gap-10">
        {benefits.map((benefit, index) => (
          <div 
            key={index} 
            className="bg-gradient-to-br from-black/40 to-black/60 p-6 sm:p-8 rounded-xl border border-red-500/20 hover:border-red-500/40 transition-all duration-500 transform hover:-translate-y-2 backdrop-blur-lg hover:shadow-[0_0_30px_rgba(239,68,68,0.2)] active:scale-[0.98] touch-manipulation"
          >
            <div className="bg-gradient-to-br from-red-500/10 to-red-500/5 w-14 h-14 sm:w-16 sm:h-16 rounded-lg flex items-center justify-center mb-4 sm:mb-6 border border-red-500/20">
              <benefit.icon className="w-7 h-7 sm:w-8 sm:h-8 text-red-500" />
            </div>
            <h3 className="text-lg sm:text-xl font-bold mb-2 sm:mb-3 text-white bg-gradient-to-r from-white to-white/90 bg-clip-text text-transparent">{benefit.title}</h3>
            <p className="text-sm sm:text-base text-gray-400 leading-relaxed">{benefit.desc}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
